import * as Types from '../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetDocumentRecordQueryVariables = Types.Exact<{
  documentId: Types.Scalars['Float']['input'];
  mode: Types.Scalars['String']['input'];
}>;


export type GetDocumentRecordQuery = { __typename?: 'Query', getDocumentRecord?: { __typename?: 'DocumentRecord', masterDataRefreshed?: boolean | null, changedFields?: Array<string> | null, document?: { __typename?: 'ECAPDocument', id?: number | null, documentTypeId?: number | null, documentStatusId?: number | null, companyPartnerId?: number | null, companyCode?: string | null, partnerVatCodeId?: number | null, bmwIsRetailOutlet?: boolean | null, bmwBusinessAreaId?: number | null, bmwBusinessUnitId?: number | null, bmwContactName?: string | null, bmwContactDepartment?: string | null, bmwContactTelephone?: string | null, bmwContactEmail?: string | null, currencyCodeId?: string | null, localCurrencyCodeId?: string | null, exchangeRate?: number | null, exchangeRateDate?: string | null, documentNumber?: string | null, documentDate?: string | null, orderNumber?: string | null, deliveryNumber?: string | null, deliveryDate?: string | null, documentFormatId?: number | null, processCodeId?: number | null, originalInvoiceNumber?: string | null, agreementReference?: string | null, headerText?: string | null, footerText?: string | null, grossAmount?: number | null, netAmount?: number | null, taxAmount?: number | null, taxableAmount?: number | null, localCurrencyGrossAmount?: number | null, localCurrencyTaxAmount?: number | null, localCurrencyTaxableAmount?: number | null, localCurrencyNetAmount?: number | null, paymentTerms?: string | null, bmwGroupPaymentRequest?: boolean | null, companyVatCodeId?: number | null, documentType?: string | null, documentTypePhraseId?: string | null, documentTypeDescription?: string | null, documentTypeDescriptionPhraseId?: string | null, documentStatus?: string | null, documentStatusPhraseId?: string | null, partnerVatCode?: string | null, partnerVatCountry?: string | null, partnerId?: number | null, partnerName?: string | null, companyName?: string | null, companyVatCode?: string | null, companyId?: number | null, bmwCompanyTaxId?: string | null, partnerNo?: string | null, earlyPaymentDiscountDate?: string | null, earlyPaymentDiscountDueDate?: string | null, earlyPaymentDescription?: string | null, isTemplateDocument?: boolean | null, bmwCompanyCity?: string | null, bmwCompanyCountryCode?: string | null, bmwCompanyPostalCode?: string | null, bmwCompanyStreet1?: string | null, bmwCompanyStreet2?: string | null, isOrderNumberNotRequired?: boolean | null } | null, shippingInformation?: { __typename?: 'ShippingInformation', ecDocumentShippingInfoId?: number | null, shipFromCity?: string | null, shipFromContact?: string | null, shipFromCountryCode?: string | null, shipFromCountry?: string | null, shipFromCountryPhraseId?: string | null, shipFromDepartment?: string | null, shipFromPostalCode?: string | null, shipFromRegionCode?: string | null, shipFromRegion?: string | null, shipFromRegionPhraseId?: string | null, shipFromStreet?: string | null, shipToCity?: string | null, shipFromName?: string | null, shipToContact?: string | null, shipToCountryCode?: string | null, shipToCountry?: string | null, shipToCountryPhraseId?: string | null, shipToDepartment?: string | null, shipToPostalCode?: string | null, shipToRegionCode?: string | null, shipToRegion?: string | null, shipToRegionPhraseId?: string | null, shipToStreet?: string | null, shipToName?: string | null } | null, supplierDetails?: { __typename?: 'SupplierDetails', documentPartnerProfileId?: number | null, bankAccountNumber?: string | null, bankBranchCode?: string | null, bankIban?: string | null, bankSwiftBicNumber?: string | null, placeOfRegistration?: string | null, managingDirector?: string | null, legalFormType?: string | null, legalFormTypeId?: number | null, liquidationRemark?: string | null, inLiquidation?: boolean | null, hasFiscalRepresentative?: boolean | null, chairmanOfSupervisoryBoard?: string | null, companyRegistrationNumber?: string | null, companyRegistryData?: string | null, contactDepartment?: string | null, contactEmail?: string | null, contactName?: string | null, contactTelephone?: string | null, fiscalRepresentativeAddressCity?: string | null, fiscalRepresentativeAddressPostalCode?: string | null, fiscalRepresentativeAddressCountryCode?: string | null, fiscalRepresentativeAddressCountry?: string | null, fiscalRepresentativeAddressCountryPhraseId?: string | null, fiscalRepresentativeAddressRegionCode?: string | null, fiscalRepresentativeAddressRegion?: string | null, fiscalRepresentativeAddressRegionPhraseId?: string | null, fiscalRepresentativeAddressStreet?: string | null, fiscalRepresentativeName?: string | null, fiscalRepresentativeVatId?: string | null, partnerVatCode?: string | null, partnerVatCountryCode?: string | null, companyVatCode?: string | null, companyVatCountryCode?: string | null, partnerNo?: string | null, partnerName?: string | null, systemCode?: string | null, street1?: string | null, street2?: string | null, postalCode?: string | null, regionCode?: string | null, city?: string | null, countryCode?: string | null, partnerTaxId?: string | null, companyCode?: string | null, companyName?: string | null } | null, lineItems?: Array<{ __typename?: 'LineItems', ecDocumentDetailId?: number | null, ecDocumentId?: number | null, lineNo?: number | null, deliveryDate?: string | null, deliveryNo?: string | null, quantity?: number | null, grossAmount?: number | null, itemDescription?: string | null, netAmount?: number | null, orderNumber?: string | null, taxAmount?: number | null, taxRate?: number | null, unitPrice?: number | null, unitQuantity?: number | null, unitOfMeasureFreeText?: string | null, bmwPartnerNumber?: string | null, unitOfMeasureId?: number | null, toolLocation?: string | null, toolSupplyingCountry?: string | null, srmReferenceNumber?: string | null, inventoryNumber?: string | null, taxExemptionTypeId?: number | null, taxLawReferenceId?: number | null, exemptionReason?: string | null }> | null, agreementHistory?: { __typename?: 'AgreementHistory', id?: number | null, agreementAcceptedDate?: string | null, companyPartnerId?: number | null } | null, documentTemplate?: { __typename?: 'DocumentTemplate', id?: number | null, templateName?: string | null } | null } | null };

export type GetPartnerVatInfoByPartnerNoQueryVariables = Types.Exact<{
  partnerNo: Types.Scalars['String']['input'];
  companyCode: Types.Scalars['String']['input'];
}>;


export type GetPartnerVatInfoByPartnerNoQuery = { __typename?: 'Query', getPartnerVATInfoByPartnerNo?: { __typename?: 'PartnerWithVATCodes', partnerId?: number | null, partnerName?: string | null, taxId?: string | null, vatCodes?: Array<{ __typename?: 'PartnerVATCodes', country?: string | null, partnerName?: string | null, vatCode?: string | null, partnerVatId?: number | null }> | null } | null };

export type GetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesQueryVariables = Types.Exact<{
  partnerNo: Types.Scalars['String']['input'];
  companyCode: Types.Scalars['String']['input'];
  systemCode: Types.Scalars['String']['input'];
  categories: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type GetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesQuery = { __typename?: 'Query', getPartnerVATInfoByPartnerNoCodSystemCodeCategories?: { __typename?: 'PartnerWithVATCodes', partnerId?: number | null, partnerName?: string | null, taxId?: string | null, vatCodes?: Array<{ __typename?: 'PartnerVATCodes', country?: string | null, partnerName?: string | null, vatCode?: string | null, partnerVatId?: number | null }> | null } | null };

export type GetCountryListQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCountryListQuery = { __typename?: 'Query', getCountryList?: Array<{ __typename?: 'CountryCode', id: string, country?: string | null, phraseId?: string | null, isEuMemberState?: boolean | null, defaultCurrencyCode?: { __typename?: 'CurrencyCode', id: string, currencyName?: string | null, currencySymbol?: string | null, decimalPlaces?: number | null } | null }> | null };

export type GetCountryInfoQueryVariables = Types.Exact<{
  countryId: Types.Scalars['String']['input'];
}>;


export type GetCountryInfoQuery = { __typename?: 'Query', getCountryInfo?: { __typename?: 'CountryCode', id: string, isEuMemberState?: boolean | null, country?: string | null, defaultCurrencyCode?: { __typename?: 'CurrencyCode', currencyName?: string | null, currencySymbol?: string | null, decimalPlaces?: number | null, id: string } | null } | null };

export type GetRegionListQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetRegionListQuery = { __typename?: 'Query', getRegionList?: Array<{ __typename?: 'RegionCode', region?: string | null, phraseId?: string | null, id: { __typename?: 'RegionId', countryCode: string, regionCode: string }, countryCode?: { __typename?: 'CountryCode', id: string, isEuMemberState?: boolean | null, country?: string | null, defaultCurrencyCode?: { __typename?: 'CurrencyCode', currencyName?: string | null, currencySymbol?: string | null, decimalPlaces?: number | null, id: string } | null } | null }> | null };

export type GetRegionInfoQueryVariables = Types.Exact<{
  regionId: Types.Scalars['String']['input'];
}>;


export type GetRegionInfoQuery = { __typename?: 'Query', getRegionInfo?: { __typename?: 'RegionCode', region?: string | null, phraseId?: string | null, id: { __typename?: 'RegionId', countryCode: string, regionCode: string }, countryCode?: { __typename?: 'CountryCode', id: string, isEuMemberState?: boolean | null, country?: string | null, defaultCurrencyCode?: { __typename?: 'CurrencyCode', currencyName?: string | null, currencySymbol?: string | null, decimalPlaces?: number | null, id: string } | null } | null } | null };

export type GetCurrencyListQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCurrencyListQuery = { __typename?: 'Query', getCurrencyList?: Array<{ __typename?: 'CurrencyCode', id: string, currencyName?: string | null, phraseId?: string | null, currencySymbol?: string | null, decimalPlaces?: number | null }> | null };

export type AllSupporingDocumentsResponseQueryVariables = Types.Exact<{
  docId: Types.Scalars['String']['input'];
}>;


export type AllSupporingDocumentsResponseQuery = { __typename?: 'Query', retrieveSupportingDocuments?: Array<{ __typename?: 'SupportingDocumentResponse', attachmentId?: number | null, blobId?: number | null, blobPath?: string | null, fileName?: string | null, documentId?: number | null, attachmentType?: string | null, sizeInKB?: number | null }> | null };

export type GetBusinessUnitListQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetBusinessUnitListQuery = { __typename?: 'Query', getBusinessUnitList?: Array<{ __typename?: 'BusinessUnit', id?: number | null, businessUnitCode?: string | null, businessUnitName?: string | null, insertTime?: string | null, insertUser?: string | null, updateTime?: string | null, updateUser?: string | null, phraseId?: string | null, businessArea?: { __typename?: 'BusinessArea', id?: number | null, businessAreaCode?: string | null, businessAreaName?: string | null, insertTime?: string | null, insertUser?: string | null, updateTime?: string | null, updateUser?: string | null, phraseId?: string | null, company?: { __typename?: 'Company', companyId?: number | null, companyCode?: string | null, companyName?: string | null } | null } | null }> | null };

export type GetBusinessAreaListQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetBusinessAreaListQuery = { __typename?: 'Query', getBusinessAreaList?: Array<{ __typename?: 'BusinessArea', id?: number | null, businessAreaCode?: string | null, businessAreaName?: string | null, insertTime?: string | null, insertUser?: string | null, updateTime?: string | null, updateUser?: string | null, phraseId?: string | null, company?: { __typename?: 'Company', companyId?: number | null, companyCode?: string | null, companyName?: string | null } | null }> | null };

export type AllCompanyInfoByCompanyPartnerIdQueryVariables = Types.Exact<{
  companyCode: Types.Scalars['String']['input'];
  partnerId: Types.Scalars['Float']['input'];
}>;


export type AllCompanyInfoByCompanyPartnerIdQuery = { __typename?: 'Query', allCompanyInfoByCompanyPartnerId?: Array<{ __typename?: 'CompanyInfo', companyId?: number | null, companyInfoId?: number | null, ceo?: string | null, chairman?: string | null, companyNameAddon?: string | null, companyNameShort?: string | null, contactEmail?: string | null, email?: string | null, fax?: string | null, fullAddress?: string | null, management?: string | null, phone?: string | null, registerCourt?: string | null, registerCourtShort?: string | null, taxId?: string | null, website?: string | null, companyCode?: string | null, companyName?: string | null, partnerId?: number | null, partnerNo?: string | null, partnerName?: string | null, systemId?: number | null, systemCode?: string | null, companyPartnerId?: number | null }> | null };

export type GetCompanyInfoByCompanyPartnerNoQueryVariables = Types.Exact<{
  companyCode: Types.Scalars['String']['input'];
  partnerNo: Types.Scalars['String']['input'];
}>;


export type GetCompanyInfoByCompanyPartnerNoQuery = { __typename?: 'Query', getCompanyInfoByCompanyPartnerNo?: { __typename?: 'CompanyInfo', companyId?: number | null, companyInfoId?: number | null, ceo?: string | null, chairman?: string | null, companyNameAddon?: string | null, companyNameShort?: string | null, contactEmail?: string | null, email?: string | null, fax?: string | null, fullAddress?: string | null, management?: string | null, phone?: string | null, registerCourt?: string | null, registerCourtShort?: string | null, taxId?: string | null, website?: string | null, companyCode?: string | null, companyName?: string | null, partnerId?: number | null, partnerNo?: string | null, partnerName?: string | null, systemId?: number | null, systemCode?: string | null, companyPartnerId?: number | null } | null };

export type GetCompanyInfoByCompanyPartnerNoCategoryQueryVariables = Types.Exact<{
  companyCode: Types.Scalars['String']['input'];
  partnerNo: Types.Scalars['String']['input'];
  systemCode: Types.Scalars['String']['input'];
  category: Types.Scalars['String']['input'];
}>;


export type GetCompanyInfoByCompanyPartnerNoCategoryQuery = { __typename?: 'Query', getCompanyInfoByCompanyPartnerNoCategory?: { __typename?: 'CompanyInfo', companyId?: number | null, companyInfoId?: number | null, ceo?: string | null, chairman?: string | null, companyNameAddon?: string | null, companyNameShort?: string | null, contactEmail?: string | null, email?: string | null, fax?: string | null, fullAddress?: string | null, management?: string | null, phone?: string | null, registerCourt?: string | null, registerCourtShort?: string | null, taxId?: string | null, website?: string | null, companyCode?: string | null, companyName?: string | null, partnerId?: number | null, partnerNo?: string | null, partnerName?: string | null, systemId?: number | null, systemCode?: string | null, companyPartnerId?: number | null } | null };

export type GetCompanyAddressDetailsByCompanyIdQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Float']['input'];
  addressType: Types.Scalars['String']['input'];
}>;


export type GetCompanyAddressDetailsByCompanyIdQuery = { __typename?: 'Query', getCompanyAddressDetailsByCompanyId?: Array<{ __typename?: 'CompanyAddress', addressType?: string | null, AddressTypeCode?: string | null, addressTypePhraseId?: string | null, city?: string | null, companyAddressId?: number | null, country?: string | null, countryCode?: string | null, poBox?: string | null, postalCode?: string | null, street1?: string | null, street2?: string | null, region?: string | null }> | null };

export type GetPartnerByCompanyPartnerIdQueryVariables = Types.Exact<{
  companyPartnerId: Types.Scalars['Float']['input'];
}>;


export type GetPartnerByCompanyPartnerIdQuery = { __typename?: 'Query', getPartnerByCompanyPartnerId?: { __typename?: 'CompanyPartner', systemId?: number | null, systemCompanyId?: number | null, companyId?: number | null, companyPartnerId?: number | null, partnerId?: number | null, systemCode?: string | null, companyCode?: string | null, partnerNo?: string | null, partnerName?: string | null, category?: string | null, companyName?: string | null } | null };

export type GetPartnerAddressByPartnerIdQueryVariables = Types.Exact<{
  partnerId: Types.Scalars['Float']['input'];
  pageNumber: Types.Scalars['Float']['input'];
  pageSize: Types.Scalars['Float']['input'];
}>;


export type GetPartnerAddressByPartnerIdQuery = { __typename?: 'Query', getPartnerAddressByPartnerId?: Array<{ __typename?: 'PartnerAddressData', street1?: string | null, street2?: string | null, city?: string | null, countryCode?: string | null, country?: string | null, regionCode?: string | null, region?: string | null, postalcodePobox?: string | null, postalCode?: string | null, updateTime?: string | null, partnerNo?: string | null, partnerName?: string | null }> | null };

export type GetFilteredRulesWithRuleTypeQueryVariables = Types.Exact<{
  ruleType: Types.Scalars['String']['input'];
}>;


export type GetFilteredRulesWithRuleTypeQuery = { __typename?: 'Query', getFilteredRulesWithRuleType?: Array<{ __typename?: 'Rules', ruleId?: number | null, ruleTypeId?: number | null, ruleType?: string | null, stopRule?: boolean | null, priority?: number | null, ruleCategory?: string | null, definition?: string | null }> | null };

export type DraftDocumentListQueryVariables = Types.Exact<{
  draftListInput: Types.DraftListInput;
}>;


export type DraftDocumentListQuery = { __typename?: 'Query', DraftDocumentList?: Array<{ __typename?: 'DraftList', id?: number | null, documentNumber?: string | null, documentDate?: string | null, documentType?: string | null, bmwCompany?: string | null, partnerNumber?: string | null, partnerName?: string | null, currency?: string | null, grossAmount?: number | null, taxAmount?: number | null, lastUpdate?: string | null, phraseId?: string | null, tpUser?: string | null }> | null };

export type AllVatCodesByCompanyIdQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Float']['input'];
}>;


export type AllVatCodesByCompanyIdQuery = { __typename?: 'Query', allVatCodesByCompanyId?: Array<{ __typename?: 'VatCodes', id?: number | null, vatCode?: string | null, company?: { __typename?: 'Company', companyId?: number | null, companyCode?: string | null, companyName?: string | null } | null, countryCode?: { __typename?: 'CountryCode', id: string, country?: string | null, isEuMemberState?: boolean | null, defaultCurrencyCode?: { __typename?: 'CurrencyCode', id: string, currencyName?: string | null, currencySymbol?: string | null, decimalPlaces?: number | null } | null } | null }> | null };

export type GetCompanyDefaultTaxIdQueryVariables = Types.Exact<{
  companyCode: Types.Scalars['String']['input'];
  companyVatCountryCode: Types.Scalars['String']['input'];
}>;


export type GetCompanyDefaultTaxIdQuery = { __typename?: 'Query', getCompanyDefaultTaxId?: { __typename?: 'CompanyDefaultTaxId', companyTaxDefaultId?: number | null, taxId?: string | null, companyCode?: { __typename?: 'Company', companyId?: number | null, companyCode?: string | null, companyName?: string | null } | null, countryCode?: { __typename?: 'CountryCode', id: string, country?: string | null, phraseId?: string | null, isEuMemberState?: boolean | null, defaultCurrencyCode?: { __typename?: 'CurrencyCode', id: string, currencyName?: string | null, phraseId?: string | null, currencySymbol?: string | null, decimalPlaces?: number | null } | null } | null } | null };

export type TaxLawReferenceApiQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type TaxLawReferenceApiQuery = { __typename?: 'Query', getTaxLawReferences?: Array<{ __typename?: 'TaxLawReference', id?: number | null, phraseId?: string | null, taxLawReference?: string | null, taxTypeCode?: string | null }> | null, getTaxExemptions?: Array<{ __typename?: 'ExemptionType', id?: number | null, phraseId?: string | null, taxExemptionType?: string | null, taxLawReferenceId?: number | null }> | null };

export type UnitOfMeasureApiQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UnitOfMeasureApiQuery = { __typename?: 'Query', getAllUnitOfMeasureValues?: Array<{ __typename?: 'UnitOfMeasure', decimalPlaces?: number | null, id?: number | null, unitOfMeasureAllowDecimal?: boolean | null, unitOfMeasureDescription?: string | null, unitOfMeasureSymbol?: string | null }> | null };

export type Get_Invoice_Agreement_HistoryQueryVariables = Types.Exact<{
  companyPartnerId: Types.Scalars['Float']['input'];
}>;


export type Get_Invoice_Agreement_HistoryQuery = { __typename?: 'Query', getAgreementHistory: { __typename?: 'ECAPAgreementHistory', agreementHistoryId?: number | null, agreementId?: number | null, agreementName?: string | null, agreementAcceptedByUserId?: number | null, agreementAcceptedDate?: string | null, agreementAcceptedUser?: string | null, agreementDescription?: string | null, blobId?: string | null } };

export type Get_Invoice_Agreement_History_V2QueryVariables = Types.Exact<{
  partnerNo: Types.Scalars['String']['input'];
  companyCode: Types.Scalars['String']['input'];
  systemCode: Types.Scalars['String']['input'];
}>;


export type Get_Invoice_Agreement_History_V2Query = { __typename?: 'Query', getAgreementHistoryV2: { __typename?: 'ECAPAgreementHistory', agreementHistoryId?: number | null, agreementId?: number | null, agreementName?: string | null, agreementAcceptedByUserId?: number | null, agreementAcceptedDate?: string | null, agreementAcceptedUser?: string | null, agreementDescription?: string | null, blobId?: string | null } };

export type Get_Invoice_Agreement_InfoQueryVariables = Types.Exact<{
  companyCode: Types.Scalars['String']['input'];
  languageCode: Types.Scalars['String']['input'];
  moduleCode: Types.Scalars['String']['input'];
  category: Types.Scalars['String']['input'];
}>;


export type Get_Invoice_Agreement_InfoQuery = { __typename?: 'Query', getAgreementInfo: Array<{ __typename?: 'ECAPAgreementInfo', agreementId?: number | null, agreementName?: string | null, agreementDescription?: string | null, blobId?: number | null, languageCode?: string | null }> };

export type DownloadEcapDocumentApiQueryVariables = Types.Exact<{
  blobId: Types.Scalars['Float']['input'];
}>;


export type DownloadEcapDocumentApiQuery = { __typename?: 'Query', downloadECapDocument: { __typename?: 'SurveyDocumentResponse', success?: string | null, value?: { __typename?: 'SurveyDocumentValue', encodedFileData?: string | null, fileName?: string | null, mimeType?: string | null } | null } };


export const GetDocumentRecordDocument = gql`
    query getDocumentRecord($documentId: Float!, $mode: String!) {
  getDocumentRecord(documentId: $documentId, mode: $mode) {
    document {
      id
      documentTypeId
      documentStatusId
      companyPartnerId
      companyCode
      partnerVatCodeId
      bmwIsRetailOutlet
      bmwBusinessAreaId
      bmwBusinessUnitId
      bmwContactName
      bmwContactDepartment
      bmwContactDepartment
      bmwContactTelephone
      bmwContactTelephone
      bmwContactEmail
      currencyCodeId
      localCurrencyCodeId
      exchangeRate
      exchangeRateDate
      documentNumber
      documentDate
      orderNumber
      deliveryNumber
      deliveryDate
      documentFormatId
      processCodeId
      originalInvoiceNumber
      agreementReference
      headerText
      footerText
      grossAmount
      netAmount
      taxAmount
      taxableAmount
      localCurrencyGrossAmount
      localCurrencyTaxAmount
      localCurrencyTaxableAmount
      localCurrencyNetAmount
      paymentTerms
      bmwGroupPaymentRequest
      companyVatCodeId
      documentType
      documentTypePhraseId
      documentTypeDescription
      documentTypeDescriptionPhraseId
      documentStatus
      documentStatusPhraseId
      partnerVatCode
      partnerVatCountry
      partnerId
      partnerName
      companyName
      companyVatCode
      companyId
      bmwCompanyTaxId
      partnerNo
      earlyPaymentDiscountDate
      earlyPaymentDiscountDueDate
      earlyPaymentDescription
      isTemplateDocument
      bmwCompanyCity
      bmwCompanyCountryCode
      bmwCompanyPostalCode
      bmwCompanyStreet1
      bmwCompanyStreet2
      isOrderNumberNotRequired
    }
    shippingInformation {
      ecDocumentShippingInfoId
      shipFromCity
      shipFromContact
      shipFromCountryCode
      shipFromCountry
      shipFromCountryPhraseId
      shipFromDepartment
      shipFromPostalCode
      shipFromRegionCode
      shipFromRegion
      shipFromRegionPhraseId
      shipFromStreet
      shipToCity
      shipFromName
      shipToContact
      shipToCountryCode
      shipToCountry
      shipToCountryPhraseId
      shipToDepartment
      shipToPostalCode
      shipToRegionCode
      shipToRegion
      shipToRegionPhraseId
      shipToStreet
      shipToName
    }
    supplierDetails {
      documentPartnerProfileId
      bankAccountNumber
      bankBranchCode
      bankIban
      bankSwiftBicNumber
      placeOfRegistration
      managingDirector
      legalFormType
      legalFormTypeId
      liquidationRemark
      inLiquidation
      hasFiscalRepresentative
      chairmanOfSupervisoryBoard
      companyRegistrationNumber
      companyRegistryData
      contactDepartment
      contactEmail
      contactName
      contactTelephone
      fiscalRepresentativeAddressCity
      fiscalRepresentativeAddressPostalCode
      fiscalRepresentativeAddressCountryCode
      fiscalRepresentativeAddressCountry
      fiscalRepresentativeAddressCountryPhraseId
      fiscalRepresentativeAddressRegionCode
      fiscalRepresentativeAddressRegion
      fiscalRepresentativeAddressRegionPhraseId
      fiscalRepresentativeAddressStreet
      fiscalRepresentativeName
      fiscalRepresentativeVatId
      partnerVatCode
      partnerVatCountryCode
      companyVatCode
      companyVatCountryCode
      partnerNo
      partnerName
      systemCode
      street1
      street2
      postalCode
      regionCode
      city
      countryCode
      partnerTaxId
      companyCode
      companyName
    }
    lineItems {
      ecDocumentDetailId
      ecDocumentId
      lineNo
      deliveryDate
      deliveryNo
      quantity
      grossAmount
      itemDescription
      netAmount
      orderNumber
      taxAmount
      taxRate
      unitPrice
      unitQuantity
      unitOfMeasureFreeText
      bmwPartnerNumber
      unitOfMeasureId
      toolLocation
      toolSupplyingCountry
      srmReferenceNumber
      inventoryNumber
      taxExemptionTypeId
      taxLawReferenceId
      exemptionReason
    }
    agreementHistory {
      id
      agreementAcceptedDate
      companyPartnerId
    }
    documentTemplate {
      id
      templateName
    }
    masterDataRefreshed
    changedFields
  }
}
    `;

/**
 * __useGetDocumentRecordQuery__
 *
 * To run a query within a React component, call `useGetDocumentRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentRecordQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      mode: // value for 'mode'
 *   },
 * });
 */
export function useGetDocumentRecordQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentRecordQuery, GetDocumentRecordQueryVariables> & ({ variables: GetDocumentRecordQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentRecordQuery, GetDocumentRecordQueryVariables>(GetDocumentRecordDocument, options);
      }
export function useGetDocumentRecordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentRecordQuery, GetDocumentRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentRecordQuery, GetDocumentRecordQueryVariables>(GetDocumentRecordDocument, options);
        }
// @ts-ignore
export function useGetDocumentRecordSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDocumentRecordQuery, GetDocumentRecordQueryVariables>): Apollo.UseSuspenseQueryResult<GetDocumentRecordQuery, GetDocumentRecordQueryVariables>;
export function useGetDocumentRecordSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentRecordQuery, GetDocumentRecordQueryVariables>): Apollo.UseSuspenseQueryResult<GetDocumentRecordQuery | undefined, GetDocumentRecordQueryVariables>;
export function useGetDocumentRecordSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentRecordQuery, GetDocumentRecordQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDocumentRecordQuery, GetDocumentRecordQueryVariables>(GetDocumentRecordDocument, options);
        }
export type GetDocumentRecordQueryHookResult = ReturnType<typeof useGetDocumentRecordQuery>;
export type GetDocumentRecordLazyQueryHookResult = ReturnType<typeof useGetDocumentRecordLazyQuery>;
export type GetDocumentRecordSuspenseQueryHookResult = ReturnType<typeof useGetDocumentRecordSuspenseQuery>;
export type GetDocumentRecordQueryResult = Apollo.QueryResult<GetDocumentRecordQuery, GetDocumentRecordQueryVariables>;
export const GetPartnerVatInfoByPartnerNoDocument = gql`
    query getPartnerVATInfoByPartnerNo($partnerNo: String!, $companyCode: String!) {
  getPartnerVATInfoByPartnerNo(partnerNo: $partnerNo, companyCode: $companyCode) {
    partnerId
    partnerName
    taxId
    vatCodes {
      country
      partnerName
      partnerName
      vatCode
      partnerVatId
    }
  }
}
    `;

/**
 * __useGetPartnerVatInfoByPartnerNoQuery__
 *
 * To run a query within a React component, call `useGetPartnerVatInfoByPartnerNoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerVatInfoByPartnerNoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerVatInfoByPartnerNoQuery({
 *   variables: {
 *      partnerNo: // value for 'partnerNo'
 *      companyCode: // value for 'companyCode'
 *   },
 * });
 */
export function useGetPartnerVatInfoByPartnerNoQuery(baseOptions: Apollo.QueryHookOptions<GetPartnerVatInfoByPartnerNoQuery, GetPartnerVatInfoByPartnerNoQueryVariables> & ({ variables: GetPartnerVatInfoByPartnerNoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnerVatInfoByPartnerNoQuery, GetPartnerVatInfoByPartnerNoQueryVariables>(GetPartnerVatInfoByPartnerNoDocument, options);
      }
export function useGetPartnerVatInfoByPartnerNoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnerVatInfoByPartnerNoQuery, GetPartnerVatInfoByPartnerNoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnerVatInfoByPartnerNoQuery, GetPartnerVatInfoByPartnerNoQueryVariables>(GetPartnerVatInfoByPartnerNoDocument, options);
        }
// @ts-ignore
export function useGetPartnerVatInfoByPartnerNoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPartnerVatInfoByPartnerNoQuery, GetPartnerVatInfoByPartnerNoQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartnerVatInfoByPartnerNoQuery, GetPartnerVatInfoByPartnerNoQueryVariables>;
export function useGetPartnerVatInfoByPartnerNoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartnerVatInfoByPartnerNoQuery, GetPartnerVatInfoByPartnerNoQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartnerVatInfoByPartnerNoQuery | undefined, GetPartnerVatInfoByPartnerNoQueryVariables>;
export function useGetPartnerVatInfoByPartnerNoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartnerVatInfoByPartnerNoQuery, GetPartnerVatInfoByPartnerNoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPartnerVatInfoByPartnerNoQuery, GetPartnerVatInfoByPartnerNoQueryVariables>(GetPartnerVatInfoByPartnerNoDocument, options);
        }
export type GetPartnerVatInfoByPartnerNoQueryHookResult = ReturnType<typeof useGetPartnerVatInfoByPartnerNoQuery>;
export type GetPartnerVatInfoByPartnerNoLazyQueryHookResult = ReturnType<typeof useGetPartnerVatInfoByPartnerNoLazyQuery>;
export type GetPartnerVatInfoByPartnerNoSuspenseQueryHookResult = ReturnType<typeof useGetPartnerVatInfoByPartnerNoSuspenseQuery>;
export type GetPartnerVatInfoByPartnerNoQueryResult = Apollo.QueryResult<GetPartnerVatInfoByPartnerNoQuery, GetPartnerVatInfoByPartnerNoQueryVariables>;
export const GetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesDocument = gql`
    query getPartnerVATInfoByPartnerNoCodSystemCodeCategories($partnerNo: String!, $companyCode: String!, $systemCode: String!, $categories: [String!]!) {
  getPartnerVATInfoByPartnerNoCodSystemCodeCategories(
    partnerNo: $partnerNo
    companyCode: $companyCode
    systemCode: $systemCode
    categories: $categories
  ) {
    partnerId
    partnerName
    taxId
    vatCodes {
      country
      partnerName
      partnerName
      vatCode
      partnerVatId
    }
  }
}
    `;

/**
 * __useGetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesQuery__
 *
 * To run a query within a React component, call `useGetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesQuery({
 *   variables: {
 *      partnerNo: // value for 'partnerNo'
 *      companyCode: // value for 'companyCode'
 *      systemCode: // value for 'systemCode'
 *      categories: // value for 'categories'
 *   },
 * });
 */
export function useGetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesQuery, GetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesQueryVariables> & ({ variables: GetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesQuery, GetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesQueryVariables>(GetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesDocument, options);
      }
export function useGetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesQuery, GetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesQuery, GetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesQueryVariables>(GetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesDocument, options);
        }
// @ts-ignore
export function useGetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesQuery, GetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesQuery, GetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesQueryVariables>;
export function useGetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesQuery, GetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesQuery | undefined, GetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesQueryVariables>;
export function useGetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesQuery, GetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesQuery, GetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesQueryVariables>(GetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesDocument, options);
        }
export type GetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesQueryHookResult = ReturnType<typeof useGetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesQuery>;
export type GetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesLazyQueryHookResult = ReturnType<typeof useGetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesLazyQuery>;
export type GetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesSuspenseQuery>;
export type GetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesQueryResult = Apollo.QueryResult<GetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesQuery, GetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesQueryVariables>;
export const GetCountryListDocument = gql`
    query getCountryList {
  getCountryList {
    id
    country
    phraseId
    isEuMemberState
    defaultCurrencyCode {
      id
      currencyName
      currencySymbol
      decimalPlaces
    }
  }
}
    `;

/**
 * __useGetCountryListQuery__
 *
 * To run a query within a React component, call `useGetCountryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountryListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountryListQuery(baseOptions?: Apollo.QueryHookOptions<GetCountryListQuery, GetCountryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountryListQuery, GetCountryListQueryVariables>(GetCountryListDocument, options);
      }
export function useGetCountryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountryListQuery, GetCountryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountryListQuery, GetCountryListQueryVariables>(GetCountryListDocument, options);
        }
// @ts-ignore
export function useGetCountryListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCountryListQuery, GetCountryListQueryVariables>): Apollo.UseSuspenseQueryResult<GetCountryListQuery, GetCountryListQueryVariables>;
export function useGetCountryListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCountryListQuery, GetCountryListQueryVariables>): Apollo.UseSuspenseQueryResult<GetCountryListQuery | undefined, GetCountryListQueryVariables>;
export function useGetCountryListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCountryListQuery, GetCountryListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCountryListQuery, GetCountryListQueryVariables>(GetCountryListDocument, options);
        }
export type GetCountryListQueryHookResult = ReturnType<typeof useGetCountryListQuery>;
export type GetCountryListLazyQueryHookResult = ReturnType<typeof useGetCountryListLazyQuery>;
export type GetCountryListSuspenseQueryHookResult = ReturnType<typeof useGetCountryListSuspenseQuery>;
export type GetCountryListQueryResult = Apollo.QueryResult<GetCountryListQuery, GetCountryListQueryVariables>;
export const GetCountryInfoDocument = gql`
    query getCountryInfo($countryId: String!) {
  getCountryInfo(countryId: $countryId) {
    id
    isEuMemberState
    country
    defaultCurrencyCode {
      currencyName
      currencySymbol
      decimalPlaces
      id
    }
  }
}
    `;

/**
 * __useGetCountryInfoQuery__
 *
 * To run a query within a React component, call `useGetCountryInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountryInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountryInfoQuery({
 *   variables: {
 *      countryId: // value for 'countryId'
 *   },
 * });
 */
export function useGetCountryInfoQuery(baseOptions: Apollo.QueryHookOptions<GetCountryInfoQuery, GetCountryInfoQueryVariables> & ({ variables: GetCountryInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountryInfoQuery, GetCountryInfoQueryVariables>(GetCountryInfoDocument, options);
      }
export function useGetCountryInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountryInfoQuery, GetCountryInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountryInfoQuery, GetCountryInfoQueryVariables>(GetCountryInfoDocument, options);
        }
// @ts-ignore
export function useGetCountryInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCountryInfoQuery, GetCountryInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetCountryInfoQuery, GetCountryInfoQueryVariables>;
export function useGetCountryInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCountryInfoQuery, GetCountryInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetCountryInfoQuery | undefined, GetCountryInfoQueryVariables>;
export function useGetCountryInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCountryInfoQuery, GetCountryInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCountryInfoQuery, GetCountryInfoQueryVariables>(GetCountryInfoDocument, options);
        }
export type GetCountryInfoQueryHookResult = ReturnType<typeof useGetCountryInfoQuery>;
export type GetCountryInfoLazyQueryHookResult = ReturnType<typeof useGetCountryInfoLazyQuery>;
export type GetCountryInfoSuspenseQueryHookResult = ReturnType<typeof useGetCountryInfoSuspenseQuery>;
export type GetCountryInfoQueryResult = Apollo.QueryResult<GetCountryInfoQuery, GetCountryInfoQueryVariables>;
export const GetRegionListDocument = gql`
    query getRegionList {
  getRegionList {
    id {
      countryCode
      regionCode
    }
    region
    phraseId
    countryCode {
      id
      isEuMemberState
      country
      defaultCurrencyCode {
        currencyName
        currencySymbol
        decimalPlaces
        id
      }
    }
  }
}
    `;

/**
 * __useGetRegionListQuery__
 *
 * To run a query within a React component, call `useGetRegionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegionListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRegionListQuery(baseOptions?: Apollo.QueryHookOptions<GetRegionListQuery, GetRegionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegionListQuery, GetRegionListQueryVariables>(GetRegionListDocument, options);
      }
export function useGetRegionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegionListQuery, GetRegionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegionListQuery, GetRegionListQueryVariables>(GetRegionListDocument, options);
        }
// @ts-ignore
export function useGetRegionListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRegionListQuery, GetRegionListQueryVariables>): Apollo.UseSuspenseQueryResult<GetRegionListQuery, GetRegionListQueryVariables>;
export function useGetRegionListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRegionListQuery, GetRegionListQueryVariables>): Apollo.UseSuspenseQueryResult<GetRegionListQuery | undefined, GetRegionListQueryVariables>;
export function useGetRegionListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRegionListQuery, GetRegionListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRegionListQuery, GetRegionListQueryVariables>(GetRegionListDocument, options);
        }
export type GetRegionListQueryHookResult = ReturnType<typeof useGetRegionListQuery>;
export type GetRegionListLazyQueryHookResult = ReturnType<typeof useGetRegionListLazyQuery>;
export type GetRegionListSuspenseQueryHookResult = ReturnType<typeof useGetRegionListSuspenseQuery>;
export type GetRegionListQueryResult = Apollo.QueryResult<GetRegionListQuery, GetRegionListQueryVariables>;
export const GetRegionInfoDocument = gql`
    query getRegionInfo($regionId: String!) {
  getRegionInfo(regionId: $regionId) {
    id {
      countryCode
      regionCode
    }
    region
    phraseId
    countryCode {
      id
      isEuMemberState
      country
      defaultCurrencyCode {
        currencyName
        currencySymbol
        decimalPlaces
        id
      }
    }
  }
}
    `;

/**
 * __useGetRegionInfoQuery__
 *
 * To run a query within a React component, call `useGetRegionInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegionInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegionInfoQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useGetRegionInfoQuery(baseOptions: Apollo.QueryHookOptions<GetRegionInfoQuery, GetRegionInfoQueryVariables> & ({ variables: GetRegionInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegionInfoQuery, GetRegionInfoQueryVariables>(GetRegionInfoDocument, options);
      }
export function useGetRegionInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegionInfoQuery, GetRegionInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegionInfoQuery, GetRegionInfoQueryVariables>(GetRegionInfoDocument, options);
        }
// @ts-ignore
export function useGetRegionInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRegionInfoQuery, GetRegionInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetRegionInfoQuery, GetRegionInfoQueryVariables>;
export function useGetRegionInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRegionInfoQuery, GetRegionInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetRegionInfoQuery | undefined, GetRegionInfoQueryVariables>;
export function useGetRegionInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRegionInfoQuery, GetRegionInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRegionInfoQuery, GetRegionInfoQueryVariables>(GetRegionInfoDocument, options);
        }
export type GetRegionInfoQueryHookResult = ReturnType<typeof useGetRegionInfoQuery>;
export type GetRegionInfoLazyQueryHookResult = ReturnType<typeof useGetRegionInfoLazyQuery>;
export type GetRegionInfoSuspenseQueryHookResult = ReturnType<typeof useGetRegionInfoSuspenseQuery>;
export type GetRegionInfoQueryResult = Apollo.QueryResult<GetRegionInfoQuery, GetRegionInfoQueryVariables>;
export const GetCurrencyListDocument = gql`
    query getCurrencyList {
  getCurrencyList {
    id
    currencyName
    phraseId
    currencySymbol
    decimalPlaces
  }
}
    `;

/**
 * __useGetCurrencyListQuery__
 *
 * To run a query within a React component, call `useGetCurrencyListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrencyListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrencyListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrencyListQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrencyListQuery, GetCurrencyListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrencyListQuery, GetCurrencyListQueryVariables>(GetCurrencyListDocument, options);
      }
export function useGetCurrencyListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrencyListQuery, GetCurrencyListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrencyListQuery, GetCurrencyListQueryVariables>(GetCurrencyListDocument, options);
        }
// @ts-ignore
export function useGetCurrencyListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrencyListQuery, GetCurrencyListQueryVariables>): Apollo.UseSuspenseQueryResult<GetCurrencyListQuery, GetCurrencyListQueryVariables>;
export function useGetCurrencyListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrencyListQuery, GetCurrencyListQueryVariables>): Apollo.UseSuspenseQueryResult<GetCurrencyListQuery | undefined, GetCurrencyListQueryVariables>;
export function useGetCurrencyListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrencyListQuery, GetCurrencyListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrencyListQuery, GetCurrencyListQueryVariables>(GetCurrencyListDocument, options);
        }
export type GetCurrencyListQueryHookResult = ReturnType<typeof useGetCurrencyListQuery>;
export type GetCurrencyListLazyQueryHookResult = ReturnType<typeof useGetCurrencyListLazyQuery>;
export type GetCurrencyListSuspenseQueryHookResult = ReturnType<typeof useGetCurrencyListSuspenseQuery>;
export type GetCurrencyListQueryResult = Apollo.QueryResult<GetCurrencyListQuery, GetCurrencyListQueryVariables>;
export const AllSupporingDocumentsResponseDocument = gql`
    query AllSupporingDocumentsResponse($docId: String!) {
  retrieveSupportingDocuments(documentId: $docId) {
    attachmentId
    blobId
    blobPath
    fileName
    documentId
    attachmentType
    sizeInKB
  }
}
    `;

/**
 * __useAllSupporingDocumentsResponseQuery__
 *
 * To run a query within a React component, call `useAllSupporingDocumentsResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSupporingDocumentsResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSupporingDocumentsResponseQuery({
 *   variables: {
 *      docId: // value for 'docId'
 *   },
 * });
 */
export function useAllSupporingDocumentsResponseQuery(baseOptions: Apollo.QueryHookOptions<AllSupporingDocumentsResponseQuery, AllSupporingDocumentsResponseQueryVariables> & ({ variables: AllSupporingDocumentsResponseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllSupporingDocumentsResponseQuery, AllSupporingDocumentsResponseQueryVariables>(AllSupporingDocumentsResponseDocument, options);
      }
export function useAllSupporingDocumentsResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllSupporingDocumentsResponseQuery, AllSupporingDocumentsResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllSupporingDocumentsResponseQuery, AllSupporingDocumentsResponseQueryVariables>(AllSupporingDocumentsResponseDocument, options);
        }
// @ts-ignore
export function useAllSupporingDocumentsResponseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllSupporingDocumentsResponseQuery, AllSupporingDocumentsResponseQueryVariables>): Apollo.UseSuspenseQueryResult<AllSupporingDocumentsResponseQuery, AllSupporingDocumentsResponseQueryVariables>;
export function useAllSupporingDocumentsResponseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllSupporingDocumentsResponseQuery, AllSupporingDocumentsResponseQueryVariables>): Apollo.UseSuspenseQueryResult<AllSupporingDocumentsResponseQuery | undefined, AllSupporingDocumentsResponseQueryVariables>;
export function useAllSupporingDocumentsResponseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllSupporingDocumentsResponseQuery, AllSupporingDocumentsResponseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllSupporingDocumentsResponseQuery, AllSupporingDocumentsResponseQueryVariables>(AllSupporingDocumentsResponseDocument, options);
        }
export type AllSupporingDocumentsResponseQueryHookResult = ReturnType<typeof useAllSupporingDocumentsResponseQuery>;
export type AllSupporingDocumentsResponseLazyQueryHookResult = ReturnType<typeof useAllSupporingDocumentsResponseLazyQuery>;
export type AllSupporingDocumentsResponseSuspenseQueryHookResult = ReturnType<typeof useAllSupporingDocumentsResponseSuspenseQuery>;
export type AllSupporingDocumentsResponseQueryResult = Apollo.QueryResult<AllSupporingDocumentsResponseQuery, AllSupporingDocumentsResponseQueryVariables>;
export const GetBusinessUnitListDocument = gql`
    query getBusinessUnitList {
  getBusinessUnitList {
    id
    businessUnitCode
    businessUnitName
    insertTime
    insertUser
    updateTime
    updateUser
    phraseId
    businessArea {
      id
      businessAreaCode
      businessAreaName
      insertTime
      insertUser
      updateTime
      updateUser
      phraseId
      company {
        companyId
        companyCode
        companyName
      }
    }
  }
}
    `;

/**
 * __useGetBusinessUnitListQuery__
 *
 * To run a query within a React component, call `useGetBusinessUnitListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessUnitListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessUnitListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBusinessUnitListQuery(baseOptions?: Apollo.QueryHookOptions<GetBusinessUnitListQuery, GetBusinessUnitListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessUnitListQuery, GetBusinessUnitListQueryVariables>(GetBusinessUnitListDocument, options);
      }
export function useGetBusinessUnitListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessUnitListQuery, GetBusinessUnitListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessUnitListQuery, GetBusinessUnitListQueryVariables>(GetBusinessUnitListDocument, options);
        }
// @ts-ignore
export function useGetBusinessUnitListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBusinessUnitListQuery, GetBusinessUnitListQueryVariables>): Apollo.UseSuspenseQueryResult<GetBusinessUnitListQuery, GetBusinessUnitListQueryVariables>;
export function useGetBusinessUnitListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBusinessUnitListQuery, GetBusinessUnitListQueryVariables>): Apollo.UseSuspenseQueryResult<GetBusinessUnitListQuery | undefined, GetBusinessUnitListQueryVariables>;
export function useGetBusinessUnitListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBusinessUnitListQuery, GetBusinessUnitListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBusinessUnitListQuery, GetBusinessUnitListQueryVariables>(GetBusinessUnitListDocument, options);
        }
export type GetBusinessUnitListQueryHookResult = ReturnType<typeof useGetBusinessUnitListQuery>;
export type GetBusinessUnitListLazyQueryHookResult = ReturnType<typeof useGetBusinessUnitListLazyQuery>;
export type GetBusinessUnitListSuspenseQueryHookResult = ReturnType<typeof useGetBusinessUnitListSuspenseQuery>;
export type GetBusinessUnitListQueryResult = Apollo.QueryResult<GetBusinessUnitListQuery, GetBusinessUnitListQueryVariables>;
export const GetBusinessAreaListDocument = gql`
    query getBusinessAreaList {
  getBusinessAreaList {
    id
    businessAreaCode
    businessAreaName
    insertTime
    insertUser
    updateTime
    updateUser
    phraseId
    company {
      companyId
      companyCode
      companyName
    }
  }
}
    `;

/**
 * __useGetBusinessAreaListQuery__
 *
 * To run a query within a React component, call `useGetBusinessAreaListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessAreaListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessAreaListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBusinessAreaListQuery(baseOptions?: Apollo.QueryHookOptions<GetBusinessAreaListQuery, GetBusinessAreaListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessAreaListQuery, GetBusinessAreaListQueryVariables>(GetBusinessAreaListDocument, options);
      }
export function useGetBusinessAreaListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessAreaListQuery, GetBusinessAreaListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessAreaListQuery, GetBusinessAreaListQueryVariables>(GetBusinessAreaListDocument, options);
        }
// @ts-ignore
export function useGetBusinessAreaListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBusinessAreaListQuery, GetBusinessAreaListQueryVariables>): Apollo.UseSuspenseQueryResult<GetBusinessAreaListQuery, GetBusinessAreaListQueryVariables>;
export function useGetBusinessAreaListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBusinessAreaListQuery, GetBusinessAreaListQueryVariables>): Apollo.UseSuspenseQueryResult<GetBusinessAreaListQuery | undefined, GetBusinessAreaListQueryVariables>;
export function useGetBusinessAreaListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBusinessAreaListQuery, GetBusinessAreaListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBusinessAreaListQuery, GetBusinessAreaListQueryVariables>(GetBusinessAreaListDocument, options);
        }
export type GetBusinessAreaListQueryHookResult = ReturnType<typeof useGetBusinessAreaListQuery>;
export type GetBusinessAreaListLazyQueryHookResult = ReturnType<typeof useGetBusinessAreaListLazyQuery>;
export type GetBusinessAreaListSuspenseQueryHookResult = ReturnType<typeof useGetBusinessAreaListSuspenseQuery>;
export type GetBusinessAreaListQueryResult = Apollo.QueryResult<GetBusinessAreaListQuery, GetBusinessAreaListQueryVariables>;
export const AllCompanyInfoByCompanyPartnerIdDocument = gql`
    query allCompanyInfoByCompanyPartnerId($companyCode: String!, $partnerId: Float!) {
  allCompanyInfoByCompanyPartnerId(
    companyCode: $companyCode
    partnerId: $partnerId
  ) {
    companyId
    companyInfoId
    ceo
    chairman
    companyNameAddon
    companyNameShort
    contactEmail
    email
    fax
    fullAddress
    management
    phone
    registerCourt
    registerCourtShort
    taxId
    website
    companyCode
    companyName
    partnerId
    partnerNo
    partnerName
    systemId
    systemCode
    companyPartnerId
  }
}
    `;

/**
 * __useAllCompanyInfoByCompanyPartnerIdQuery__
 *
 * To run a query within a React component, call `useAllCompanyInfoByCompanyPartnerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCompanyInfoByCompanyPartnerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCompanyInfoByCompanyPartnerIdQuery({
 *   variables: {
 *      companyCode: // value for 'companyCode'
 *      partnerId: // value for 'partnerId'
 *   },
 * });
 */
export function useAllCompanyInfoByCompanyPartnerIdQuery(baseOptions: Apollo.QueryHookOptions<AllCompanyInfoByCompanyPartnerIdQuery, AllCompanyInfoByCompanyPartnerIdQueryVariables> & ({ variables: AllCompanyInfoByCompanyPartnerIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCompanyInfoByCompanyPartnerIdQuery, AllCompanyInfoByCompanyPartnerIdQueryVariables>(AllCompanyInfoByCompanyPartnerIdDocument, options);
      }
export function useAllCompanyInfoByCompanyPartnerIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCompanyInfoByCompanyPartnerIdQuery, AllCompanyInfoByCompanyPartnerIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCompanyInfoByCompanyPartnerIdQuery, AllCompanyInfoByCompanyPartnerIdQueryVariables>(AllCompanyInfoByCompanyPartnerIdDocument, options);
        }
// @ts-ignore
export function useAllCompanyInfoByCompanyPartnerIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllCompanyInfoByCompanyPartnerIdQuery, AllCompanyInfoByCompanyPartnerIdQueryVariables>): Apollo.UseSuspenseQueryResult<AllCompanyInfoByCompanyPartnerIdQuery, AllCompanyInfoByCompanyPartnerIdQueryVariables>;
export function useAllCompanyInfoByCompanyPartnerIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllCompanyInfoByCompanyPartnerIdQuery, AllCompanyInfoByCompanyPartnerIdQueryVariables>): Apollo.UseSuspenseQueryResult<AllCompanyInfoByCompanyPartnerIdQuery | undefined, AllCompanyInfoByCompanyPartnerIdQueryVariables>;
export function useAllCompanyInfoByCompanyPartnerIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllCompanyInfoByCompanyPartnerIdQuery, AllCompanyInfoByCompanyPartnerIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllCompanyInfoByCompanyPartnerIdQuery, AllCompanyInfoByCompanyPartnerIdQueryVariables>(AllCompanyInfoByCompanyPartnerIdDocument, options);
        }
export type AllCompanyInfoByCompanyPartnerIdQueryHookResult = ReturnType<typeof useAllCompanyInfoByCompanyPartnerIdQuery>;
export type AllCompanyInfoByCompanyPartnerIdLazyQueryHookResult = ReturnType<typeof useAllCompanyInfoByCompanyPartnerIdLazyQuery>;
export type AllCompanyInfoByCompanyPartnerIdSuspenseQueryHookResult = ReturnType<typeof useAllCompanyInfoByCompanyPartnerIdSuspenseQuery>;
export type AllCompanyInfoByCompanyPartnerIdQueryResult = Apollo.QueryResult<AllCompanyInfoByCompanyPartnerIdQuery, AllCompanyInfoByCompanyPartnerIdQueryVariables>;
export const GetCompanyInfoByCompanyPartnerNoDocument = gql`
    query getCompanyInfoByCompanyPartnerNo($companyCode: String!, $partnerNo: String!) {
  getCompanyInfoByCompanyPartnerNo(
    companyCode: $companyCode
    partnerNo: $partnerNo
  ) {
    companyId
    companyInfoId
    ceo
    chairman
    companyNameAddon
    companyNameShort
    contactEmail
    email
    fax
    fullAddress
    management
    phone
    registerCourt
    registerCourtShort
    taxId
    website
    companyCode
    companyName
    partnerId
    partnerNo
    partnerName
    systemId
    systemCode
    companyPartnerId
  }
}
    `;

/**
 * __useGetCompanyInfoByCompanyPartnerNoQuery__
 *
 * To run a query within a React component, call `useGetCompanyInfoByCompanyPartnerNoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyInfoByCompanyPartnerNoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyInfoByCompanyPartnerNoQuery({
 *   variables: {
 *      companyCode: // value for 'companyCode'
 *      partnerNo: // value for 'partnerNo'
 *   },
 * });
 */
export function useGetCompanyInfoByCompanyPartnerNoQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyInfoByCompanyPartnerNoQuery, GetCompanyInfoByCompanyPartnerNoQueryVariables> & ({ variables: GetCompanyInfoByCompanyPartnerNoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyInfoByCompanyPartnerNoQuery, GetCompanyInfoByCompanyPartnerNoQueryVariables>(GetCompanyInfoByCompanyPartnerNoDocument, options);
      }
export function useGetCompanyInfoByCompanyPartnerNoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyInfoByCompanyPartnerNoQuery, GetCompanyInfoByCompanyPartnerNoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyInfoByCompanyPartnerNoQuery, GetCompanyInfoByCompanyPartnerNoQueryVariables>(GetCompanyInfoByCompanyPartnerNoDocument, options);
        }
// @ts-ignore
export function useGetCompanyInfoByCompanyPartnerNoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyInfoByCompanyPartnerNoQuery, GetCompanyInfoByCompanyPartnerNoQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyInfoByCompanyPartnerNoQuery, GetCompanyInfoByCompanyPartnerNoQueryVariables>;
export function useGetCompanyInfoByCompanyPartnerNoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyInfoByCompanyPartnerNoQuery, GetCompanyInfoByCompanyPartnerNoQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyInfoByCompanyPartnerNoQuery | undefined, GetCompanyInfoByCompanyPartnerNoQueryVariables>;
export function useGetCompanyInfoByCompanyPartnerNoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyInfoByCompanyPartnerNoQuery, GetCompanyInfoByCompanyPartnerNoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyInfoByCompanyPartnerNoQuery, GetCompanyInfoByCompanyPartnerNoQueryVariables>(GetCompanyInfoByCompanyPartnerNoDocument, options);
        }
export type GetCompanyInfoByCompanyPartnerNoQueryHookResult = ReturnType<typeof useGetCompanyInfoByCompanyPartnerNoQuery>;
export type GetCompanyInfoByCompanyPartnerNoLazyQueryHookResult = ReturnType<typeof useGetCompanyInfoByCompanyPartnerNoLazyQuery>;
export type GetCompanyInfoByCompanyPartnerNoSuspenseQueryHookResult = ReturnType<typeof useGetCompanyInfoByCompanyPartnerNoSuspenseQuery>;
export type GetCompanyInfoByCompanyPartnerNoQueryResult = Apollo.QueryResult<GetCompanyInfoByCompanyPartnerNoQuery, GetCompanyInfoByCompanyPartnerNoQueryVariables>;
export const GetCompanyInfoByCompanyPartnerNoCategoryDocument = gql`
    query getCompanyInfoByCompanyPartnerNoCategory($companyCode: String!, $partnerNo: String!, $systemCode: String!, $category: String!) {
  getCompanyInfoByCompanyPartnerNoCategory(
    companyCode: $companyCode
    partnerNo: $partnerNo
    systemCode: $systemCode
    category: $category
  ) {
    companyId
    companyInfoId
    ceo
    chairman
    companyNameAddon
    companyNameShort
    contactEmail
    email
    fax
    fullAddress
    management
    phone
    registerCourt
    registerCourtShort
    taxId
    website
    companyCode
    companyName
    partnerId
    partnerNo
    partnerName
    systemId
    systemCode
    companyPartnerId
  }
}
    `;

/**
 * __useGetCompanyInfoByCompanyPartnerNoCategoryQuery__
 *
 * To run a query within a React component, call `useGetCompanyInfoByCompanyPartnerNoCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyInfoByCompanyPartnerNoCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyInfoByCompanyPartnerNoCategoryQuery({
 *   variables: {
 *      companyCode: // value for 'companyCode'
 *      partnerNo: // value for 'partnerNo'
 *      systemCode: // value for 'systemCode'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useGetCompanyInfoByCompanyPartnerNoCategoryQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyInfoByCompanyPartnerNoCategoryQuery, GetCompanyInfoByCompanyPartnerNoCategoryQueryVariables> & ({ variables: GetCompanyInfoByCompanyPartnerNoCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyInfoByCompanyPartnerNoCategoryQuery, GetCompanyInfoByCompanyPartnerNoCategoryQueryVariables>(GetCompanyInfoByCompanyPartnerNoCategoryDocument, options);
      }
export function useGetCompanyInfoByCompanyPartnerNoCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyInfoByCompanyPartnerNoCategoryQuery, GetCompanyInfoByCompanyPartnerNoCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyInfoByCompanyPartnerNoCategoryQuery, GetCompanyInfoByCompanyPartnerNoCategoryQueryVariables>(GetCompanyInfoByCompanyPartnerNoCategoryDocument, options);
        }
// @ts-ignore
export function useGetCompanyInfoByCompanyPartnerNoCategorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyInfoByCompanyPartnerNoCategoryQuery, GetCompanyInfoByCompanyPartnerNoCategoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyInfoByCompanyPartnerNoCategoryQuery, GetCompanyInfoByCompanyPartnerNoCategoryQueryVariables>;
export function useGetCompanyInfoByCompanyPartnerNoCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyInfoByCompanyPartnerNoCategoryQuery, GetCompanyInfoByCompanyPartnerNoCategoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyInfoByCompanyPartnerNoCategoryQuery | undefined, GetCompanyInfoByCompanyPartnerNoCategoryQueryVariables>;
export function useGetCompanyInfoByCompanyPartnerNoCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyInfoByCompanyPartnerNoCategoryQuery, GetCompanyInfoByCompanyPartnerNoCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyInfoByCompanyPartnerNoCategoryQuery, GetCompanyInfoByCompanyPartnerNoCategoryQueryVariables>(GetCompanyInfoByCompanyPartnerNoCategoryDocument, options);
        }
export type GetCompanyInfoByCompanyPartnerNoCategoryQueryHookResult = ReturnType<typeof useGetCompanyInfoByCompanyPartnerNoCategoryQuery>;
export type GetCompanyInfoByCompanyPartnerNoCategoryLazyQueryHookResult = ReturnType<typeof useGetCompanyInfoByCompanyPartnerNoCategoryLazyQuery>;
export type GetCompanyInfoByCompanyPartnerNoCategorySuspenseQueryHookResult = ReturnType<typeof useGetCompanyInfoByCompanyPartnerNoCategorySuspenseQuery>;
export type GetCompanyInfoByCompanyPartnerNoCategoryQueryResult = Apollo.QueryResult<GetCompanyInfoByCompanyPartnerNoCategoryQuery, GetCompanyInfoByCompanyPartnerNoCategoryQueryVariables>;
export const GetCompanyAddressDetailsByCompanyIdDocument = gql`
    query getCompanyAddressDetailsByCompanyId($companyId: Float!, $addressType: String!) {
  getCompanyAddressDetailsByCompanyId(
    companyId: $companyId
    addressType: $addressType
  ) {
    addressType
    AddressTypeCode
    addressTypePhraseId
    city
    companyAddressId
    country
    countryCode
    poBox
    postalCode
    street1
    street2
  }
}
    `;

/**
 * __useGetCompanyAddressDetailsByCompanyIdQuery__
 *
 * To run a query within a React component, call `useGetCompanyAddressDetailsByCompanyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyAddressDetailsByCompanyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyAddressDetailsByCompanyIdQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      addressType: // value for 'addressType'
 *   },
 * });
 */
export function useGetCompanyAddressDetailsByCompanyIdQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyAddressDetailsByCompanyIdQuery, GetCompanyAddressDetailsByCompanyIdQueryVariables> & ({ variables: GetCompanyAddressDetailsByCompanyIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyAddressDetailsByCompanyIdQuery, GetCompanyAddressDetailsByCompanyIdQueryVariables>(GetCompanyAddressDetailsByCompanyIdDocument, options);
      }
export function useGetCompanyAddressDetailsByCompanyIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyAddressDetailsByCompanyIdQuery, GetCompanyAddressDetailsByCompanyIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyAddressDetailsByCompanyIdQuery, GetCompanyAddressDetailsByCompanyIdQueryVariables>(GetCompanyAddressDetailsByCompanyIdDocument, options);
        }
// @ts-ignore
export function useGetCompanyAddressDetailsByCompanyIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyAddressDetailsByCompanyIdQuery, GetCompanyAddressDetailsByCompanyIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyAddressDetailsByCompanyIdQuery, GetCompanyAddressDetailsByCompanyIdQueryVariables>;
export function useGetCompanyAddressDetailsByCompanyIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyAddressDetailsByCompanyIdQuery, GetCompanyAddressDetailsByCompanyIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyAddressDetailsByCompanyIdQuery | undefined, GetCompanyAddressDetailsByCompanyIdQueryVariables>;
export function useGetCompanyAddressDetailsByCompanyIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyAddressDetailsByCompanyIdQuery, GetCompanyAddressDetailsByCompanyIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyAddressDetailsByCompanyIdQuery, GetCompanyAddressDetailsByCompanyIdQueryVariables>(GetCompanyAddressDetailsByCompanyIdDocument, options);
        }
export type GetCompanyAddressDetailsByCompanyIdQueryHookResult = ReturnType<typeof useGetCompanyAddressDetailsByCompanyIdQuery>;
export type GetCompanyAddressDetailsByCompanyIdLazyQueryHookResult = ReturnType<typeof useGetCompanyAddressDetailsByCompanyIdLazyQuery>;
export type GetCompanyAddressDetailsByCompanyIdSuspenseQueryHookResult = ReturnType<typeof useGetCompanyAddressDetailsByCompanyIdSuspenseQuery>;
export type GetCompanyAddressDetailsByCompanyIdQueryResult = Apollo.QueryResult<GetCompanyAddressDetailsByCompanyIdQuery, GetCompanyAddressDetailsByCompanyIdQueryVariables>;
export const GetPartnerByCompanyPartnerIdDocument = gql`
    query getPartnerByCompanyPartnerId($companyPartnerId: Float!) {
  getPartnerByCompanyPartnerId(companyPartnerId: $companyPartnerId) {
    systemId
    systemCompanyId
    companyId
    companyPartnerId
    partnerId
    systemCode
    companyCode
    partnerNo
    partnerName
    category
    companyName
  }
}
    `;

/**
 * __useGetPartnerByCompanyPartnerIdQuery__
 *
 * To run a query within a React component, call `useGetPartnerByCompanyPartnerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerByCompanyPartnerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerByCompanyPartnerIdQuery({
 *   variables: {
 *      companyPartnerId: // value for 'companyPartnerId'
 *   },
 * });
 */
export function useGetPartnerByCompanyPartnerIdQuery(baseOptions: Apollo.QueryHookOptions<GetPartnerByCompanyPartnerIdQuery, GetPartnerByCompanyPartnerIdQueryVariables> & ({ variables: GetPartnerByCompanyPartnerIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnerByCompanyPartnerIdQuery, GetPartnerByCompanyPartnerIdQueryVariables>(GetPartnerByCompanyPartnerIdDocument, options);
      }
export function useGetPartnerByCompanyPartnerIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnerByCompanyPartnerIdQuery, GetPartnerByCompanyPartnerIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnerByCompanyPartnerIdQuery, GetPartnerByCompanyPartnerIdQueryVariables>(GetPartnerByCompanyPartnerIdDocument, options);
        }
// @ts-ignore
export function useGetPartnerByCompanyPartnerIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPartnerByCompanyPartnerIdQuery, GetPartnerByCompanyPartnerIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartnerByCompanyPartnerIdQuery, GetPartnerByCompanyPartnerIdQueryVariables>;
export function useGetPartnerByCompanyPartnerIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartnerByCompanyPartnerIdQuery, GetPartnerByCompanyPartnerIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartnerByCompanyPartnerIdQuery | undefined, GetPartnerByCompanyPartnerIdQueryVariables>;
export function useGetPartnerByCompanyPartnerIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartnerByCompanyPartnerIdQuery, GetPartnerByCompanyPartnerIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPartnerByCompanyPartnerIdQuery, GetPartnerByCompanyPartnerIdQueryVariables>(GetPartnerByCompanyPartnerIdDocument, options);
        }
export type GetPartnerByCompanyPartnerIdQueryHookResult = ReturnType<typeof useGetPartnerByCompanyPartnerIdQuery>;
export type GetPartnerByCompanyPartnerIdLazyQueryHookResult = ReturnType<typeof useGetPartnerByCompanyPartnerIdLazyQuery>;
export type GetPartnerByCompanyPartnerIdSuspenseQueryHookResult = ReturnType<typeof useGetPartnerByCompanyPartnerIdSuspenseQuery>;
export type GetPartnerByCompanyPartnerIdQueryResult = Apollo.QueryResult<GetPartnerByCompanyPartnerIdQuery, GetPartnerByCompanyPartnerIdQueryVariables>;
export const GetPartnerAddressByPartnerIdDocument = gql`
    query getPartnerAddressByPartnerId($partnerId: Float!, $pageNumber: Float!, $pageSize: Float!) {
  getPartnerAddressByPartnerId(
    partnerId: $partnerId
    pageNumber: $pageNumber
    pageSize: $pageSize
  ) {
    street1
    street2
    city
    countryCode
    country
    regionCode
    region
    postalcodePobox
    postalCode
    updateTime
    partnerNo
    partnerName
  }
}
    `;

/**
 * __useGetPartnerAddressByPartnerIdQuery__
 *
 * To run a query within a React component, call `useGetPartnerAddressByPartnerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerAddressByPartnerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerAddressByPartnerIdQuery({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *      pageNumber: // value for 'pageNumber'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetPartnerAddressByPartnerIdQuery(baseOptions: Apollo.QueryHookOptions<GetPartnerAddressByPartnerIdQuery, GetPartnerAddressByPartnerIdQueryVariables> & ({ variables: GetPartnerAddressByPartnerIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnerAddressByPartnerIdQuery, GetPartnerAddressByPartnerIdQueryVariables>(GetPartnerAddressByPartnerIdDocument, options);
      }
export function useGetPartnerAddressByPartnerIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnerAddressByPartnerIdQuery, GetPartnerAddressByPartnerIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnerAddressByPartnerIdQuery, GetPartnerAddressByPartnerIdQueryVariables>(GetPartnerAddressByPartnerIdDocument, options);
        }
// @ts-ignore
export function useGetPartnerAddressByPartnerIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPartnerAddressByPartnerIdQuery, GetPartnerAddressByPartnerIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartnerAddressByPartnerIdQuery, GetPartnerAddressByPartnerIdQueryVariables>;
export function useGetPartnerAddressByPartnerIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartnerAddressByPartnerIdQuery, GetPartnerAddressByPartnerIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartnerAddressByPartnerIdQuery | undefined, GetPartnerAddressByPartnerIdQueryVariables>;
export function useGetPartnerAddressByPartnerIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartnerAddressByPartnerIdQuery, GetPartnerAddressByPartnerIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPartnerAddressByPartnerIdQuery, GetPartnerAddressByPartnerIdQueryVariables>(GetPartnerAddressByPartnerIdDocument, options);
        }
export type GetPartnerAddressByPartnerIdQueryHookResult = ReturnType<typeof useGetPartnerAddressByPartnerIdQuery>;
export type GetPartnerAddressByPartnerIdLazyQueryHookResult = ReturnType<typeof useGetPartnerAddressByPartnerIdLazyQuery>;
export type GetPartnerAddressByPartnerIdSuspenseQueryHookResult = ReturnType<typeof useGetPartnerAddressByPartnerIdSuspenseQuery>;
export type GetPartnerAddressByPartnerIdQueryResult = Apollo.QueryResult<GetPartnerAddressByPartnerIdQuery, GetPartnerAddressByPartnerIdQueryVariables>;
export const GetFilteredRulesWithRuleTypeDocument = gql`
    query getFilteredRulesWithRuleType($ruleType: String!) {
  getFilteredRulesWithRuleType(ruleType: $ruleType) {
    ruleId
    ruleTypeId
    ruleType
    stopRule
    priority
    ruleCategory
    definition
  }
}
    `;

/**
 * __useGetFilteredRulesWithRuleTypeQuery__
 *
 * To run a query within a React component, call `useGetFilteredRulesWithRuleTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilteredRulesWithRuleTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilteredRulesWithRuleTypeQuery({
 *   variables: {
 *      ruleType: // value for 'ruleType'
 *   },
 * });
 */
export function useGetFilteredRulesWithRuleTypeQuery(baseOptions: Apollo.QueryHookOptions<GetFilteredRulesWithRuleTypeQuery, GetFilteredRulesWithRuleTypeQueryVariables> & ({ variables: GetFilteredRulesWithRuleTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilteredRulesWithRuleTypeQuery, GetFilteredRulesWithRuleTypeQueryVariables>(GetFilteredRulesWithRuleTypeDocument, options);
      }
export function useGetFilteredRulesWithRuleTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilteredRulesWithRuleTypeQuery, GetFilteredRulesWithRuleTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilteredRulesWithRuleTypeQuery, GetFilteredRulesWithRuleTypeQueryVariables>(GetFilteredRulesWithRuleTypeDocument, options);
        }
// @ts-ignore
export function useGetFilteredRulesWithRuleTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFilteredRulesWithRuleTypeQuery, GetFilteredRulesWithRuleTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GetFilteredRulesWithRuleTypeQuery, GetFilteredRulesWithRuleTypeQueryVariables>;
export function useGetFilteredRulesWithRuleTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFilteredRulesWithRuleTypeQuery, GetFilteredRulesWithRuleTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GetFilteredRulesWithRuleTypeQuery | undefined, GetFilteredRulesWithRuleTypeQueryVariables>;
export function useGetFilteredRulesWithRuleTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFilteredRulesWithRuleTypeQuery, GetFilteredRulesWithRuleTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFilteredRulesWithRuleTypeQuery, GetFilteredRulesWithRuleTypeQueryVariables>(GetFilteredRulesWithRuleTypeDocument, options);
        }
export type GetFilteredRulesWithRuleTypeQueryHookResult = ReturnType<typeof useGetFilteredRulesWithRuleTypeQuery>;
export type GetFilteredRulesWithRuleTypeLazyQueryHookResult = ReturnType<typeof useGetFilteredRulesWithRuleTypeLazyQuery>;
export type GetFilteredRulesWithRuleTypeSuspenseQueryHookResult = ReturnType<typeof useGetFilteredRulesWithRuleTypeSuspenseQuery>;
export type GetFilteredRulesWithRuleTypeQueryResult = Apollo.QueryResult<GetFilteredRulesWithRuleTypeQuery, GetFilteredRulesWithRuleTypeQueryVariables>;
export const DraftDocumentListDocument = gql`
    query DraftDocumentList($draftListInput: DraftListInput!) {
  DraftDocumentList(draftListInput: $draftListInput) {
    id
    documentNumber
    documentDate
    documentType
    bmwCompany
    partnerNumber
    partnerName
    currency
    grossAmount
    taxAmount
    lastUpdate
    phraseId
    tpUser
  }
}
    `;

/**
 * __useDraftDocumentListQuery__
 *
 * To run a query within a React component, call `useDraftDocumentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDraftDocumentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDraftDocumentListQuery({
 *   variables: {
 *      draftListInput: // value for 'draftListInput'
 *   },
 * });
 */
export function useDraftDocumentListQuery(baseOptions: Apollo.QueryHookOptions<DraftDocumentListQuery, DraftDocumentListQueryVariables> & ({ variables: DraftDocumentListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DraftDocumentListQuery, DraftDocumentListQueryVariables>(DraftDocumentListDocument, options);
      }
export function useDraftDocumentListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DraftDocumentListQuery, DraftDocumentListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DraftDocumentListQuery, DraftDocumentListQueryVariables>(DraftDocumentListDocument, options);
        }
// @ts-ignore
export function useDraftDocumentListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DraftDocumentListQuery, DraftDocumentListQueryVariables>): Apollo.UseSuspenseQueryResult<DraftDocumentListQuery, DraftDocumentListQueryVariables>;
export function useDraftDocumentListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DraftDocumentListQuery, DraftDocumentListQueryVariables>): Apollo.UseSuspenseQueryResult<DraftDocumentListQuery | undefined, DraftDocumentListQueryVariables>;
export function useDraftDocumentListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DraftDocumentListQuery, DraftDocumentListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DraftDocumentListQuery, DraftDocumentListQueryVariables>(DraftDocumentListDocument, options);
        }
export type DraftDocumentListQueryHookResult = ReturnType<typeof useDraftDocumentListQuery>;
export type DraftDocumentListLazyQueryHookResult = ReturnType<typeof useDraftDocumentListLazyQuery>;
export type DraftDocumentListSuspenseQueryHookResult = ReturnType<typeof useDraftDocumentListSuspenseQuery>;
export type DraftDocumentListQueryResult = Apollo.QueryResult<DraftDocumentListQuery, DraftDocumentListQueryVariables>;
export const AllVatCodesByCompanyIdDocument = gql`
    query allVatCodesByCompanyId($companyId: Float!) {
  allVatCodesByCompanyId(companyId: $companyId) {
    company {
      companyId
      companyCode
      companyName
    }
    id
    vatCode
    countryCode {
      id
      country
      isEuMemberState
      defaultCurrencyCode {
        id
        currencyName
        currencySymbol
        decimalPlaces
      }
    }
  }
}
    `;

/**
 * __useAllVatCodesByCompanyIdQuery__
 *
 * To run a query within a React component, call `useAllVatCodesByCompanyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllVatCodesByCompanyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllVatCodesByCompanyIdQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useAllVatCodesByCompanyIdQuery(baseOptions: Apollo.QueryHookOptions<AllVatCodesByCompanyIdQuery, AllVatCodesByCompanyIdQueryVariables> & ({ variables: AllVatCodesByCompanyIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllVatCodesByCompanyIdQuery, AllVatCodesByCompanyIdQueryVariables>(AllVatCodesByCompanyIdDocument, options);
      }
export function useAllVatCodesByCompanyIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllVatCodesByCompanyIdQuery, AllVatCodesByCompanyIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllVatCodesByCompanyIdQuery, AllVatCodesByCompanyIdQueryVariables>(AllVatCodesByCompanyIdDocument, options);
        }
// @ts-ignore
export function useAllVatCodesByCompanyIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllVatCodesByCompanyIdQuery, AllVatCodesByCompanyIdQueryVariables>): Apollo.UseSuspenseQueryResult<AllVatCodesByCompanyIdQuery, AllVatCodesByCompanyIdQueryVariables>;
export function useAllVatCodesByCompanyIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllVatCodesByCompanyIdQuery, AllVatCodesByCompanyIdQueryVariables>): Apollo.UseSuspenseQueryResult<AllVatCodesByCompanyIdQuery | undefined, AllVatCodesByCompanyIdQueryVariables>;
export function useAllVatCodesByCompanyIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllVatCodesByCompanyIdQuery, AllVatCodesByCompanyIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllVatCodesByCompanyIdQuery, AllVatCodesByCompanyIdQueryVariables>(AllVatCodesByCompanyIdDocument, options);
        }
export type AllVatCodesByCompanyIdQueryHookResult = ReturnType<typeof useAllVatCodesByCompanyIdQuery>;
export type AllVatCodesByCompanyIdLazyQueryHookResult = ReturnType<typeof useAllVatCodesByCompanyIdLazyQuery>;
export type AllVatCodesByCompanyIdSuspenseQueryHookResult = ReturnType<typeof useAllVatCodesByCompanyIdSuspenseQuery>;
export type AllVatCodesByCompanyIdQueryResult = Apollo.QueryResult<AllVatCodesByCompanyIdQuery, AllVatCodesByCompanyIdQueryVariables>;
export const GetCompanyDefaultTaxIdDocument = gql`
    query getCompanyDefaultTaxId($companyCode: String!, $companyVatCountryCode: String!) {
  getCompanyDefaultTaxId(
    companyCode: $companyCode
    companyVatCountryCode: $companyVatCountryCode
  ) {
    companyCode {
      companyId
      companyCode
      companyName
    }
    companyTaxDefaultId
    countryCode {
      id
      country
      phraseId
      isEuMemberState
      defaultCurrencyCode {
        id
        currencyName
        phraseId
        phraseId
        currencySymbol
        decimalPlaces
      }
    }
    taxId
  }
}
    `;

/**
 * __useGetCompanyDefaultTaxIdQuery__
 *
 * To run a query within a React component, call `useGetCompanyDefaultTaxIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyDefaultTaxIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyDefaultTaxIdQuery({
 *   variables: {
 *      companyCode: // value for 'companyCode'
 *      companyVatCountryCode: // value for 'companyVatCountryCode'
 *   },
 * });
 */
export function useGetCompanyDefaultTaxIdQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyDefaultTaxIdQuery, GetCompanyDefaultTaxIdQueryVariables> & ({ variables: GetCompanyDefaultTaxIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyDefaultTaxIdQuery, GetCompanyDefaultTaxIdQueryVariables>(GetCompanyDefaultTaxIdDocument, options);
      }
export function useGetCompanyDefaultTaxIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyDefaultTaxIdQuery, GetCompanyDefaultTaxIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyDefaultTaxIdQuery, GetCompanyDefaultTaxIdQueryVariables>(GetCompanyDefaultTaxIdDocument, options);
        }
// @ts-ignore
export function useGetCompanyDefaultTaxIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyDefaultTaxIdQuery, GetCompanyDefaultTaxIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyDefaultTaxIdQuery, GetCompanyDefaultTaxIdQueryVariables>;
export function useGetCompanyDefaultTaxIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyDefaultTaxIdQuery, GetCompanyDefaultTaxIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyDefaultTaxIdQuery | undefined, GetCompanyDefaultTaxIdQueryVariables>;
export function useGetCompanyDefaultTaxIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyDefaultTaxIdQuery, GetCompanyDefaultTaxIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyDefaultTaxIdQuery, GetCompanyDefaultTaxIdQueryVariables>(GetCompanyDefaultTaxIdDocument, options);
        }
export type GetCompanyDefaultTaxIdQueryHookResult = ReturnType<typeof useGetCompanyDefaultTaxIdQuery>;
export type GetCompanyDefaultTaxIdLazyQueryHookResult = ReturnType<typeof useGetCompanyDefaultTaxIdLazyQuery>;
export type GetCompanyDefaultTaxIdSuspenseQueryHookResult = ReturnType<typeof useGetCompanyDefaultTaxIdSuspenseQuery>;
export type GetCompanyDefaultTaxIdQueryResult = Apollo.QueryResult<GetCompanyDefaultTaxIdQuery, GetCompanyDefaultTaxIdQueryVariables>;
export const TaxLawReferenceApiDocument = gql`
    query TaxLawReferenceAPI {
  getTaxLawReferences {
    id
    phraseId
    taxLawReference
    taxTypeCode
  }
  getTaxExemptions {
    id
    phraseId
    taxExemptionType
    taxLawReferenceId
  }
}
    `;

/**
 * __useTaxLawReferenceApiQuery__
 *
 * To run a query within a React component, call `useTaxLawReferenceApiQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaxLawReferenceApiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaxLawReferenceApiQuery({
 *   variables: {
 *   },
 * });
 */
export function useTaxLawReferenceApiQuery(baseOptions?: Apollo.QueryHookOptions<TaxLawReferenceApiQuery, TaxLawReferenceApiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaxLawReferenceApiQuery, TaxLawReferenceApiQueryVariables>(TaxLawReferenceApiDocument, options);
      }
export function useTaxLawReferenceApiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaxLawReferenceApiQuery, TaxLawReferenceApiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaxLawReferenceApiQuery, TaxLawReferenceApiQueryVariables>(TaxLawReferenceApiDocument, options);
        }
// @ts-ignore
export function useTaxLawReferenceApiSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TaxLawReferenceApiQuery, TaxLawReferenceApiQueryVariables>): Apollo.UseSuspenseQueryResult<TaxLawReferenceApiQuery, TaxLawReferenceApiQueryVariables>;
export function useTaxLawReferenceApiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaxLawReferenceApiQuery, TaxLawReferenceApiQueryVariables>): Apollo.UseSuspenseQueryResult<TaxLawReferenceApiQuery | undefined, TaxLawReferenceApiQueryVariables>;
export function useTaxLawReferenceApiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaxLawReferenceApiQuery, TaxLawReferenceApiQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaxLawReferenceApiQuery, TaxLawReferenceApiQueryVariables>(TaxLawReferenceApiDocument, options);
        }
export type TaxLawReferenceApiQueryHookResult = ReturnType<typeof useTaxLawReferenceApiQuery>;
export type TaxLawReferenceApiLazyQueryHookResult = ReturnType<typeof useTaxLawReferenceApiLazyQuery>;
export type TaxLawReferenceApiSuspenseQueryHookResult = ReturnType<typeof useTaxLawReferenceApiSuspenseQuery>;
export type TaxLawReferenceApiQueryResult = Apollo.QueryResult<TaxLawReferenceApiQuery, TaxLawReferenceApiQueryVariables>;
export const UnitOfMeasureApiDocument = gql`
    query UnitOfMeasureAPI {
  getAllUnitOfMeasureValues {
    decimalPlaces
    id
    unitOfMeasureAllowDecimal
    unitOfMeasureDescription
    unitOfMeasureSymbol
  }
}
    `;

/**
 * __useUnitOfMeasureApiQuery__
 *
 * To run a query within a React component, call `useUnitOfMeasureApiQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnitOfMeasureApiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitOfMeasureApiQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnitOfMeasureApiQuery(baseOptions?: Apollo.QueryHookOptions<UnitOfMeasureApiQuery, UnitOfMeasureApiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnitOfMeasureApiQuery, UnitOfMeasureApiQueryVariables>(UnitOfMeasureApiDocument, options);
      }
export function useUnitOfMeasureApiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnitOfMeasureApiQuery, UnitOfMeasureApiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnitOfMeasureApiQuery, UnitOfMeasureApiQueryVariables>(UnitOfMeasureApiDocument, options);
        }
// @ts-ignore
export function useUnitOfMeasureApiSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UnitOfMeasureApiQuery, UnitOfMeasureApiQueryVariables>): Apollo.UseSuspenseQueryResult<UnitOfMeasureApiQuery, UnitOfMeasureApiQueryVariables>;
export function useUnitOfMeasureApiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UnitOfMeasureApiQuery, UnitOfMeasureApiQueryVariables>): Apollo.UseSuspenseQueryResult<UnitOfMeasureApiQuery | undefined, UnitOfMeasureApiQueryVariables>;
export function useUnitOfMeasureApiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UnitOfMeasureApiQuery, UnitOfMeasureApiQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UnitOfMeasureApiQuery, UnitOfMeasureApiQueryVariables>(UnitOfMeasureApiDocument, options);
        }
export type UnitOfMeasureApiQueryHookResult = ReturnType<typeof useUnitOfMeasureApiQuery>;
export type UnitOfMeasureApiLazyQueryHookResult = ReturnType<typeof useUnitOfMeasureApiLazyQuery>;
export type UnitOfMeasureApiSuspenseQueryHookResult = ReturnType<typeof useUnitOfMeasureApiSuspenseQuery>;
export type UnitOfMeasureApiQueryResult = Apollo.QueryResult<UnitOfMeasureApiQuery, UnitOfMeasureApiQueryVariables>;
export const Get_Invoice_Agreement_HistoryDocument = gql`
    query GET_invoice_agreement_history($companyPartnerId: Float!) {
  getAgreementHistory(companyPartnerId: $companyPartnerId) {
    agreementHistoryId
    agreementId
    agreementName
    agreementAcceptedByUserId
    agreementAcceptedDate
    agreementAcceptedUser
    agreementDescription
    blobId
  }
}
    `;

/**
 * __useGet_Invoice_Agreement_HistoryQuery__
 *
 * To run a query within a React component, call `useGet_Invoice_Agreement_HistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGet_Invoice_Agreement_HistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGet_Invoice_Agreement_HistoryQuery({
 *   variables: {
 *      companyPartnerId: // value for 'companyPartnerId'
 *   },
 * });
 */
export function useGet_Invoice_Agreement_HistoryQuery(baseOptions: Apollo.QueryHookOptions<Get_Invoice_Agreement_HistoryQuery, Get_Invoice_Agreement_HistoryQueryVariables> & ({ variables: Get_Invoice_Agreement_HistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Get_Invoice_Agreement_HistoryQuery, Get_Invoice_Agreement_HistoryQueryVariables>(Get_Invoice_Agreement_HistoryDocument, options);
      }
export function useGet_Invoice_Agreement_HistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Get_Invoice_Agreement_HistoryQuery, Get_Invoice_Agreement_HistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Get_Invoice_Agreement_HistoryQuery, Get_Invoice_Agreement_HistoryQueryVariables>(Get_Invoice_Agreement_HistoryDocument, options);
        }
// @ts-ignore
export function useGet_Invoice_Agreement_HistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Get_Invoice_Agreement_HistoryQuery, Get_Invoice_Agreement_HistoryQueryVariables>): Apollo.UseSuspenseQueryResult<Get_Invoice_Agreement_HistoryQuery, Get_Invoice_Agreement_HistoryQueryVariables>;
export function useGet_Invoice_Agreement_HistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Get_Invoice_Agreement_HistoryQuery, Get_Invoice_Agreement_HistoryQueryVariables>): Apollo.UseSuspenseQueryResult<Get_Invoice_Agreement_HistoryQuery | undefined, Get_Invoice_Agreement_HistoryQueryVariables>;
export function useGet_Invoice_Agreement_HistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Get_Invoice_Agreement_HistoryQuery, Get_Invoice_Agreement_HistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Get_Invoice_Agreement_HistoryQuery, Get_Invoice_Agreement_HistoryQueryVariables>(Get_Invoice_Agreement_HistoryDocument, options);
        }
export type Get_Invoice_Agreement_HistoryQueryHookResult = ReturnType<typeof useGet_Invoice_Agreement_HistoryQuery>;
export type Get_Invoice_Agreement_HistoryLazyQueryHookResult = ReturnType<typeof useGet_Invoice_Agreement_HistoryLazyQuery>;
export type Get_Invoice_Agreement_HistorySuspenseQueryHookResult = ReturnType<typeof useGet_Invoice_Agreement_HistorySuspenseQuery>;
export type Get_Invoice_Agreement_HistoryQueryResult = Apollo.QueryResult<Get_Invoice_Agreement_HistoryQuery, Get_Invoice_Agreement_HistoryQueryVariables>;
export const Get_Invoice_Agreement_History_V2Document = gql`
    query GET_invoice_agreement_history_V2($partnerNo: String!, $companyCode: String!, $systemCode: String!) {
  getAgreementHistoryV2(
    partnerNo: $partnerNo
    companyCode: $companyCode
    systemCode: $systemCode
  ) {
    agreementHistoryId
    agreementId
    agreementName
    agreementAcceptedByUserId
    agreementAcceptedDate
    agreementAcceptedUser
    agreementDescription
    blobId
  }
}
    `;

/**
 * __useGet_Invoice_Agreement_History_V2Query__
 *
 * To run a query within a React component, call `useGet_Invoice_Agreement_History_V2Query` and pass it any options that fit your needs.
 * When your component renders, `useGet_Invoice_Agreement_History_V2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGet_Invoice_Agreement_History_V2Query({
 *   variables: {
 *      partnerNo: // value for 'partnerNo'
 *      companyCode: // value for 'companyCode'
 *      systemCode: // value for 'systemCode'
 *   },
 * });
 */
export function useGet_Invoice_Agreement_History_V2Query(baseOptions: Apollo.QueryHookOptions<Get_Invoice_Agreement_History_V2Query, Get_Invoice_Agreement_History_V2QueryVariables> & ({ variables: Get_Invoice_Agreement_History_V2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Get_Invoice_Agreement_History_V2Query, Get_Invoice_Agreement_History_V2QueryVariables>(Get_Invoice_Agreement_History_V2Document, options);
      }
export function useGet_Invoice_Agreement_History_V2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Get_Invoice_Agreement_History_V2Query, Get_Invoice_Agreement_History_V2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Get_Invoice_Agreement_History_V2Query, Get_Invoice_Agreement_History_V2QueryVariables>(Get_Invoice_Agreement_History_V2Document, options);
        }
// @ts-ignore
export function useGet_Invoice_Agreement_History_V2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Get_Invoice_Agreement_History_V2Query, Get_Invoice_Agreement_History_V2QueryVariables>): Apollo.UseSuspenseQueryResult<Get_Invoice_Agreement_History_V2Query, Get_Invoice_Agreement_History_V2QueryVariables>;
export function useGet_Invoice_Agreement_History_V2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Get_Invoice_Agreement_History_V2Query, Get_Invoice_Agreement_History_V2QueryVariables>): Apollo.UseSuspenseQueryResult<Get_Invoice_Agreement_History_V2Query | undefined, Get_Invoice_Agreement_History_V2QueryVariables>;
export function useGet_Invoice_Agreement_History_V2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Get_Invoice_Agreement_History_V2Query, Get_Invoice_Agreement_History_V2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Get_Invoice_Agreement_History_V2Query, Get_Invoice_Agreement_History_V2QueryVariables>(Get_Invoice_Agreement_History_V2Document, options);
        }
export type Get_Invoice_Agreement_History_V2QueryHookResult = ReturnType<typeof useGet_Invoice_Agreement_History_V2Query>;
export type Get_Invoice_Agreement_History_V2LazyQueryHookResult = ReturnType<typeof useGet_Invoice_Agreement_History_V2LazyQuery>;
export type Get_Invoice_Agreement_History_V2SuspenseQueryHookResult = ReturnType<typeof useGet_Invoice_Agreement_History_V2SuspenseQuery>;
export type Get_Invoice_Agreement_History_V2QueryResult = Apollo.QueryResult<Get_Invoice_Agreement_History_V2Query, Get_Invoice_Agreement_History_V2QueryVariables>;
export const Get_Invoice_Agreement_InfoDocument = gql`
    query GET_invoice_agreement_info($companyCode: String!, $languageCode: String!, $moduleCode: String!, $category: String!) {
  getAgreementInfo(
    companyCode: $companyCode
    languageCode: $languageCode
    moduleCode: $moduleCode
    category: $category
  ) {
    agreementId
    agreementName
    agreementDescription
    blobId
    languageCode
  }
}
    `;

/**
 * __useGet_Invoice_Agreement_InfoQuery__
 *
 * To run a query within a React component, call `useGet_Invoice_Agreement_InfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGet_Invoice_Agreement_InfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGet_Invoice_Agreement_InfoQuery({
 *   variables: {
 *      companyCode: // value for 'companyCode'
 *      languageCode: // value for 'languageCode'
 *      moduleCode: // value for 'moduleCode'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useGet_Invoice_Agreement_InfoQuery(baseOptions: Apollo.QueryHookOptions<Get_Invoice_Agreement_InfoQuery, Get_Invoice_Agreement_InfoQueryVariables> & ({ variables: Get_Invoice_Agreement_InfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Get_Invoice_Agreement_InfoQuery, Get_Invoice_Agreement_InfoQueryVariables>(Get_Invoice_Agreement_InfoDocument, options);
      }
export function useGet_Invoice_Agreement_InfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Get_Invoice_Agreement_InfoQuery, Get_Invoice_Agreement_InfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Get_Invoice_Agreement_InfoQuery, Get_Invoice_Agreement_InfoQueryVariables>(Get_Invoice_Agreement_InfoDocument, options);
        }
// @ts-ignore
export function useGet_Invoice_Agreement_InfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Get_Invoice_Agreement_InfoQuery, Get_Invoice_Agreement_InfoQueryVariables>): Apollo.UseSuspenseQueryResult<Get_Invoice_Agreement_InfoQuery, Get_Invoice_Agreement_InfoQueryVariables>;
export function useGet_Invoice_Agreement_InfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Get_Invoice_Agreement_InfoQuery, Get_Invoice_Agreement_InfoQueryVariables>): Apollo.UseSuspenseQueryResult<Get_Invoice_Agreement_InfoQuery | undefined, Get_Invoice_Agreement_InfoQueryVariables>;
export function useGet_Invoice_Agreement_InfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Get_Invoice_Agreement_InfoQuery, Get_Invoice_Agreement_InfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Get_Invoice_Agreement_InfoQuery, Get_Invoice_Agreement_InfoQueryVariables>(Get_Invoice_Agreement_InfoDocument, options);
        }
export type Get_Invoice_Agreement_InfoQueryHookResult = ReturnType<typeof useGet_Invoice_Agreement_InfoQuery>;
export type Get_Invoice_Agreement_InfoLazyQueryHookResult = ReturnType<typeof useGet_Invoice_Agreement_InfoLazyQuery>;
export type Get_Invoice_Agreement_InfoSuspenseQueryHookResult = ReturnType<typeof useGet_Invoice_Agreement_InfoSuspenseQuery>;
export type Get_Invoice_Agreement_InfoQueryResult = Apollo.QueryResult<Get_Invoice_Agreement_InfoQuery, Get_Invoice_Agreement_InfoQueryVariables>;
export const DownloadEcapDocumentApiDocument = gql`
    query DownloadEcapDocumentAPI($blobId: Float!) {
  downloadECapDocument(blobId: $blobId) {
    success
    value {
      encodedFileData
      fileName
      mimeType
    }
  }
}
    `;

/**
 * __useDownloadEcapDocumentApiQuery__
 *
 * To run a query within a React component, call `useDownloadEcapDocumentApiQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadEcapDocumentApiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadEcapDocumentApiQuery({
 *   variables: {
 *      blobId: // value for 'blobId'
 *   },
 * });
 */
export function useDownloadEcapDocumentApiQuery(baseOptions: Apollo.QueryHookOptions<DownloadEcapDocumentApiQuery, DownloadEcapDocumentApiQueryVariables> & ({ variables: DownloadEcapDocumentApiQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadEcapDocumentApiQuery, DownloadEcapDocumentApiQueryVariables>(DownloadEcapDocumentApiDocument, options);
      }
export function useDownloadEcapDocumentApiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadEcapDocumentApiQuery, DownloadEcapDocumentApiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadEcapDocumentApiQuery, DownloadEcapDocumentApiQueryVariables>(DownloadEcapDocumentApiDocument, options);
        }
// @ts-ignore
export function useDownloadEcapDocumentApiSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DownloadEcapDocumentApiQuery, DownloadEcapDocumentApiQueryVariables>): Apollo.UseSuspenseQueryResult<DownloadEcapDocumentApiQuery, DownloadEcapDocumentApiQueryVariables>;
export function useDownloadEcapDocumentApiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadEcapDocumentApiQuery, DownloadEcapDocumentApiQueryVariables>): Apollo.UseSuspenseQueryResult<DownloadEcapDocumentApiQuery | undefined, DownloadEcapDocumentApiQueryVariables>;
export function useDownloadEcapDocumentApiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadEcapDocumentApiQuery, DownloadEcapDocumentApiQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadEcapDocumentApiQuery, DownloadEcapDocumentApiQueryVariables>(DownloadEcapDocumentApiDocument, options);
        }
export type DownloadEcapDocumentApiQueryHookResult = ReturnType<typeof useDownloadEcapDocumentApiQuery>;
export type DownloadEcapDocumentApiLazyQueryHookResult = ReturnType<typeof useDownloadEcapDocumentApiLazyQuery>;
export type DownloadEcapDocumentApiSuspenseQueryHookResult = ReturnType<typeof useDownloadEcapDocumentApiSuspenseQuery>;
export type DownloadEcapDocumentApiQueryResult = Apollo.QueryResult<DownloadEcapDocumentApiQuery, DownloadEcapDocumentApiQueryVariables>;